// @ts-nocheck
// The step-by-step create-registration wizard was retired in favor of the
// CreateRegistrationDialog + sectioned edit page. This keeps old bookmarks and
// emailed links working:
//   /create-registration/:type/:step?registrationId=X → /admin/registration/X/edit
//   /create-registration/:type/:step?tournamentId|leagueId=X → list with the create dialog preseeded
//   anything else → /admin/registration
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export default function LegacyWizardRedirect() {
  const navigate = useNavigate();
  const { contestType } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const registrationId = searchParams.get('registrationId');
    if (registrationId) {
      navigate(`/admin/registration/${registrationId}/edit`, { replace: true });
      return;
    }
    const parentId = searchParams.get('tournamentId') || searchParams.get('leagueId');
    const type = contestType === 'league' || searchParams.get('leagueId') ? 'league' : 'tournament';
    if (parentId) {
      navigate(`/admin/registration?create=${type}&parentId=${parentId}`, { replace: true });
      return;
    }
    navigate(`/admin/registration?create=${type}`, { replace: true });
  }, []);

  return null;
}
